import { amina } from "@/constants/artists/amina";
import { hailey } from "@/constants/artists/hailey";
import { josh } from "@/constants/artists/josh";
import { TutorialSample } from "@/types/types";

// Make sure the audio file length fit MIN_CONVERSION_TIME_FOR_TUTORIAL const, and decrease this const if needed Make sure the artist is actually free to use
export const tutorialSamples = [
  {
    inputFile: "/audio/tutorial/josh-rock.mp3",
    artist: josh,
    genre: "Rock",
    pitchShift: 0,
  },
  {
    inputFile: "/audio/tutorial/amina-rnb.mp3",
    artist: amina,
    genre: "RnB",
    pitchShift: 3,
  },
  {
    inputFile: "/audio/tutorial/hailey-dance.mp3",
    artist: hailey,
    genre: "Dance",
    pitchShift: 3,
  },
] as const satisfies TutorialSample[];
